var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 5.49062C27.6794 6.65651 29.2917 9.07747 29.2917 11.875C29.2917 14.6725 27.6794 17.0935 25.3334 18.2594M28.5 26.5468C30.8932 27.6297 33.0482 29.3946 34.8334 31.6667M3.16669 31.6667C6.24863 27.7441 10.4329 25.3333 15.0417 25.3333C19.6505 25.3333 23.8347 27.7441 26.9167 31.6667M22.1667 11.875C22.1667 15.81 18.9767 19 15.0417 19C11.1067 19 7.91669 15.81 7.91669 11.875C7.91669 7.93997 11.1067 4.75 15.0417 4.75C18.9767 4.75 22.1667 7.93997 22.1667 11.875Z",
    stroke: "#14B8A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers02);
export default __webpack_public_path__ + "static/media/users-02.8e4995fb9b1ea29a30b3c78e376448b3.svg";
export { ForwardRef as ReactComponent };